export type DataInfo = Info & {
  subInfo?: (Info & {
    nestedSubInfo?: Info[];
  })[];
};

type Info = {
  label: string;
  text: string;
  boldText?: boolean;
};

export const terms: DataInfo[] = [
  {
    label: '(A)',
    text: 'ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND THE TERMS.',
  },
  {
    label: '(B)',
    text: 'REPRESENT THAT YOU ARE OF LEGAL AGE TO ENTER INTO A BINDING AGREEMENT.',
  },
  {
    label: '(C)',
    text: 'ACCEPT THE TERMS AND AGREE THAT YOU ARE LEGALLY BOUND THEM. IF YOU DO NOT AGREE TO THE TERMS, YOU ARE NOT PERMITTED TO PROCEED AND MAY NOT ACCESS OR USE GATEWAY OR ANY OF THE DELIVERABLES PROVIDED THEREIN.',
  },
  {
    label: '(D)',
    text: '(FOR EXISTING VANTAGE CLIENTS) YOU AGREE THAT YOUR SERVICES MAY NOW, AT CONTROL RISKS’ DISCRETION, BE DELIVERED THROUGH GATEWAY.',
  },
];

export const jurisdictions: DataInfo[] = [
  {
    label: 'Region',
    text: 'Governing Law and Courts with Exclusive Jurisdiction',
    boldText: true,
  },
  {
    label: 'North America, Latin America or South America:',
    text: 'New York law and New York Courts',
  },
  {
    label: 'Europe, the Middle East and Africa:',
    text: 'Law of England and Wales and English Courts',
  },
  {
    label: 'Japan:',
    text: 'Japan law and Tokyo Courts',
  },
  {
    label: 'Asia/Pacific (excluding Japan and China):',
    text: 'Singapore Law and Singapore Courts',
  },
  {
    label: 'China:',
    text: 'Hong Kong Law and Hong Kong Courts',
  },
];
export const licenceToUsePlataform: DataInfo[] = [
  {
    label: 'a.',
    text: 'access Gateway for your personal, non-commercial use;',
  },
  {
    label: 'b.',
    text: 'access the content and Vantage Services made available in or otherwise accessible through Gateway; and',
  },
  {
    label: 'c.',
    text: 'obtain a printout of data, reports or other materials available (the "<strong>Materials</strong>") via printing commands of Gateway and to create a single printout of Materials downloaded via downloading commands of Gateway or your web browser (collectively, "<strong>Authorised Printouts</strong>").',
  },
];

export const licenceRestrictions: DataInfo[] = [
  {
    label: 'a.',
    text: 'share username, password, or authentication credentials with others. All access is granted by named user. Please contact your Control Risks’ account manager to grant access to additional users.',
  },
  {
    label: 'b.',
    text: 'modify, translate, adapt, or otherwise create derivative works or improvements, whether or not patentable, of Gateway or any content accessed through Gateway;',
  },
  {
    label: 'c.',
    text: 'reverse engineer, disassemble, decompile, decode, or otherwise attempt to derive or gain access to the source code of Gateway or any part thereof;',
  },
  {
    label: 'd.',
    text: 'remove, delete, alter, or obscure any trademarks or any copyright, trademark, patent, or other intellectual property or proprietary rights notices from Gateway, including any copy thereof;',
  },
  {
    label: 'e.',
    text: 'rent, lease, lend, sell, sublicense, assign, distribute, publish, transfer, or otherwise make available Gateway, or any features or functionality of Gateway, to any third party for any reason, including by making Gateway available on a network where it is capable of being accessed by more than one device at any time;',
  },
  {
    label: 'f.',
    text: 'remove, disable, circumvent, or otherwise create or implement any workaround to any copy protection, rights management, or security features in or protecting Gateway.',
  },
];

export const licenceRestrictionsIncludesFreeTrialTerms: DataInfo[] = [
  {
    label: 'a.',
    text: 'the right to electronically display Materials retrieved from the VANTAGE Services to no more than one person at a time;',
  },
  {
    label: 'b.',
    text: 'the right to obtain Authorised Printouts; and',
  },
  {
    label: 'c.',
    text: 'the right to save and store a copy of the relevant reports associated with the VANTAGE Services being trialled, as electronically transferred to you by Control Risks.',
  },
];
export const licenceRestrictionsMustNotFreeTrialTerms: DataInfo[] = [
  {
    label: 'd.',
    text: 'attempt to disassemble, reverse engineer or reverse compile, or otherwise reduce to human-perceivable form any of Gateway;',
  },
  {
    label: 'e.',
    text: "use the VANTAGE Services or Materials in any fashion that infringes our or our licensors' copyright or proprietary interests;",
  },
  {
    label: 'f.',
    text: "use information included in the VANTAGE Services or Materials retrieved from the VANTAGE Services to determine a consumer's eligibility for: (a) credit or insurance for personal, family, or household purposes; (b) employment; or (c) a government licence or beneficiary;",
  },
  {
    label: 'g.',
    text: 'remove or obscure any copyright notice or other notices contained in Materials;',
  },
  {
    label: 'h.',
    text: 'access the VANTAGE Services for purposes of monitoring its availability, performance or functionality; or',
  },
  {
    label: 'i.',
    text: 'access the VANTAGE Services if you are our direct competitor except with our prior written consent.',
  },
];
export const accessToServices: DataInfo[] = [
  {
    label: 'a.',
    text: 'Only employees authorised by the subscribing organisation and named on the attached order form may access and use the VANTAGE Services ("<strong>Authorised Users</strong>").',
  },
  {
    label: 'b.',
    text: 'You may not use an identification number to access the VANTAGE Services from outside the country for which it was issued.',
  },
  {
    label: 'c.',
    text: 'Your identification number(s) may be restricted from accessing certain Materials otherwise available in the VANTAGE Services.',
  },
  {
    label: 'd.',
    text: 'Materials and features may be added to or withdrawn from the VANTAGE Services and the VANTAGE Services otherwise changed without notice.',
  },
  {
    label: 'e.',
    text: 'You must ensure that each person having access to the VANTAGE Services and Materials:',
    subInfo: [
      {
        label: 'i.',
        text: 'is an Authorised User; and',
      },
      {
        label: 'ii.',
        text: 'is using those VANTAGE Services and Materials only in accordance with these Free Trial Terms and you will be liable for their acts and omissions at all times.',
      },
    ],
  },
];

export const limitedWarranty: DataInfo[] = [
  {
    label: 'a.',
    text: 'Control Risks warrants that it has the right and authority to make the VANTAGE Services and Materials available pursuant to these Free Trial Terms.',
  },
  {
    label: 'b.',
    text: 'EXCEPT AS OTHERWISE PROVIDED IN THIS CLAUSE 4, THE VANTAGE SERVICES AND MATERIALS ARE PROVIDED ON AN "AS IS", "AS AVAILABLE" BASIS AND VANTAGE AND EACH THIRD-PARTY SUPPLIER OF MATERIALS EXPRESSLY DISCLAIM ALL WARRANTIES, INCLUDING THE WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.',
  },
  {
    label: 'c.',
    text: 'You acknowledge that we may discontinue making the VANTAGE Services available to you at any time in our sole discretion.',
  },
];

export const limitationOfLiability: DataInfo[] = [
  {
    label: 'd.',
    text: 'A Covered Party (as defined below) shall not be liable for any loss, injury, claim, liability, or damage of any kind resulting in any way from:',
    subInfo: [
      {
        label: 'i.',
        text: 'any errors in or omissions from the VANTAGE Services or any Materials available or not included therein;',
      },
      {
        label: 'ii.',
        text: 'the unavailability or interruption of the VANTAGE Services or any features thereof or any Materials;',
      },
      {
        label: 'iii.',
        text: 'your use or misuse of the VANTAGE Services or Materials (regardless of whether you received any assistance from a Covered Party in using the VANTAGE Services);',
      },
      {
        label: 'iv.',
        text: 'your use of any equipment in connection with the VANTAGE Services;',
      },
      {
        label: 'v.',
        text: 'the content of Materials;',
      },
      {
        label: 'vi.',
        text: 'any delay or failure in performance beyond the reasonable control of a Covered Party; or',
      },
      {
        label: 'vii.',
        text: 'any negligence of a Covered Party or its employees, contractors or agents in connection with the performance of our obligations under the Free Trial Terms.',
      },
    ],
  },
  {
    label: 'e.',
    text: '"<strong>Covered Party</strong>" means (a) Control Risks, its affiliates, and any officer, director, employee, subcontractor, agent, successor, or assignee of Control Risks or its affiliates; and (b) each third party supplier of Materials, their affiliates, and any officer, director, employee, subcontractor, agent, successor, or assign of any third-party supplier of Materials or any of their affiliates.',
  },
  {
    label: 'f.',
    text: 'THE AGGREGATE LIABILITY OF THE COVERED PARTIES IN CONNECTION WITH ANY OTHER CLAIM ARISING OUT OF OR RELATING TO THE VANTAGE SERVICES OR MATERIALS SHALL NOT EXCEED THE AMOUNT OF YOUR ACTUAL DIRECT DAMAGES EXCLUDING ANY LOSS OF PROFIT OR BUSINESS WHICH IN ANY CASE SHALL NOT EXCEED US$1,000. YOUR RIGHT TO MONETARY DAMAGES IN THAT AMOUNT SHALL BE IN LIEU OF ALL OTHER REMEDIES WHICH YOU MAY HAVE AGAINST ANY COVERED PARTY.',
  },
  {
    label: 'g.',
    text: 'IN NO EVENT SHALL THE COVERED PARTIES BE LIABILE HEREUNDER TO YOU FOR ANY DAMAGES WHATSOEVER, INCLUDING BUT NOT LIMITED TO DIRECT, INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES, OR DAMAGES BASED ON LOST PROFITS, DATA OR USE, IN ANY WAY DUE TO, RESULTING FROM, OR ARISING IN CONNECTION WITH (WHETHER IN CONTRACT, TORT OR UNDER ANY OTHER THEORY OF LIABILITY) THE VANTAGE SERVICES, MATERIALS, OR THE FAILURE OF ANY COVERED PARTY TO PERFORM ITS OBLIGATIONS, REGARDLESS OF ANY NEGLIGENCE OF ANY COVERED PARTY.',
  },
  {
    label: 'h.',
    text: 'The Materials are provided for reference purposes only and are not intended, nor should they be used, as a substitute for professional advice or judgment or to provide legal advice with respect to particular circumstances.',
  },
  {
    label: 'i.',
    text: 'Whilst reasonable efforts are made to keep the Materials up to date, you should obtain independent verification or advice before relying upon any piece of information.',
  },
];

export const transferTemsforExistingClients: DataInfo[] = [
  {
    label: 'a.',
    text: 'This clause 10 relates to Existing VANTAGE Clients who have contracted with Control Risks for the provision of VANTAGE Services prior to using Gateway and whose contracts remain in force (each an "<strong>Existing Client Contract</strong>").',
  },
  {
    label: 'b.',
    text: 'In the event of a conflict between the provisions of the Terms and an Existing Client Contract the terms of the Existing Client Contract shall prevail, save for the following provisions listed below:',
    subInfo: [
      {
        label: 'i.',
        text: 'the following clauses from the Gateway General Terms of Use:',
        nestedSubInfo: [
          {
            label: '1.',
            text: 'Clause 2 (Licence to use Gateway);',
          },
          {
            label: '2.',
            text: 'Clause 3 (Licence Restrictions);',
          },
          {
            label: '3.',
            text: 'Clause 4 (Reservation of Rights);',
          },
          {
            label: '4.',
            text: 'Clause 5 (Termination of Licence);',
          },
          {
            label: '5.',
            text: 'Clause 8 (Privacy);',
          },
          {
            label: '6.',
            text: 'Clause 9 (Updates); and',
          },
          {
            label: '7.',
            text: 'Clause 11 (Multi-Factor Authentication)',
          },
          {
            label: '8.',
            text: 'Clause 12 (Free Trial Terms), and',
          },
        ],
      },
      {
        label: 'ii.',
        text: 'the Free Trial Terms.',
      },
    ],
  },
];

export const multiFactorAuth: DataInfo[] = [
  {
    label: 'a.',
    text: 'You acknowledge that, in addition to the use of an individual username and password, access to Gateway includes a multi-factor authentication ("<strong>MFA</strong>") security procedure at log-in. MFA will require you to establish and utilise, in addition to a username and password, your own individual authentication through use of an authenticator application.',
  },
  {
    label: 'b.',
    text: 'In the event you are technically prevented or otherwise unable to utilise an authenticator application to satisfy the MFA requirements, access may be authenticated through a one-time passcode sent to the email address connected with your Gateway account.',
  },
  {
    label: 'c.',
    text: 'You acknowledge that Control Risks does not accept any liability whatsoever in the event email-based authentication is utilised in lieu of the required authenticator described in clause 11(a) above.',
  },
  {
    label: 'd.',
    text: 'Control Risks reserves the right to refuse any request for use of email-based authentication.',
  },
];
